import {getLocalStorageValue} from "../../../utils/storeUtil";

export default {
    name: 'User',
    state: {},
    mutations: {
        initiateUser: (state, value) => {
            const keysToRetrieve = [];

            keysToRetrieve.forEach(({key, type}) => {
                const {hasValue, returnValue} = getLocalStorageValue(key, type);
                if (hasValue) {
                    if (hasValue) state[key] = returnValue;
                }
            });

        },
    },
    getters: {},
}
